module.exports = __webpack_public_path__ + "static/media/completed.86a1314c.png";